<template>
    <v-card>
        <div class="pa-4">
            <div class="d-flex">
                <h4>Music Credits</h4>
                <v-btn
                    class="ml-auto"
                    color="primary"
                    rounded
                    small
                    v-if="allowAdd != false"
                    @click="
                        () => {
                            this.$refs.ref_video &&
                                this.$refs.ref_video.reset();
                            this.media = [
                                {
                                    url: '',
                                    credits: '',
                                },
                            ];
                            dialog = true;
                        }
                    "
                    ><i class="fa fa-plus"></i
                ></v-btn>
            </div>
        </div>
        <v-divider></v-divider>
        <div class="pa-4">
            <div
                v-if="socialCreditLoading"
                class="d-flex align-items-center justify-center"
            >
                <v-progress-circular indeterminate />
            </div>
            <v-row v-else>
                <v-col
                    v-for="(socialCredit, i) of socialCredits"
                    :key="socialCredit.id"
                    sm="6"
                    cols="12"
                >
                    <div class="border pa-4 d-flex align-center">
                        <a :href="socialCredit.url" target="_blank">
                            <p class="ma-0">{{ socialCredit.credits }}</p>
                        </a>
                        <v-btn
                            class="ml-auto"
                            x-small
                            color="red white--text"
                            @click="
                                deleteSocialCredit({ id: authUser.id, idx: i })
                            "
                            ><i class="fa fa-trash"></i
                        ></v-btn>
                    </div>
                </v-col>

                <div class="pa-4" v-if="socialCredits.length == 0">
                    <p class="ma-0">No Music Credits Yet</p>
                </div>
            </v-row>
        </div>
        <v-dialog v-model="dialog" width="500">
            <v-card>
                <v-card-title class="text-h6 grey lighten-2">
                    Add Music Credits
                </v-card-title>
                <v-form ref="ref_video" @submit="lc_addMedia">
                    <div class="pa-4">
                        <v-text-field
                            dense
                            outlined
                            label="Reference URL"
                            v-model="media.url"
                        ></v-text-field>
                        <v-textarea
                            dense
                            outlined
                            label="Credits"
                            v-model="media.credits"
                        ></v-textarea>
                    </div>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" text type="submit"> Save </v-btn>
                        <v-btn color="primary" text @click="dialog = false">
                            Cancel
                        </v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>
export default {
    name: "CreatorType",
    props: ["audio", "allowAdd"],
    data() {
        return {
            dialog: false,
            mediaType: "",
            media: [
                {
                    credits: "",
                    url: "",
                },
            ],
        };
    },
    mounted() {
        let id = this.authUser.id;
        this.getSocialCredits(id);
    },
    methods: {
        async lc_addMedia(e) {
            e.preventDefault();
            let validate = this.$refs.ref_video.validate();
            if (validate) {
                let id = this.authUser.id;
                this.dialog = false;
                await this.addSocialCredit({ id, ...this.media });
            }
        },
        addMedia() {},
        removeMedia(idx) {},
    },
};
</script>

<style scoped>
.border {
    border: 1px solid rgba(0, 0, 0, 0.2) !important;
    border-radius: 5px;
}
a {
    text-decoration: none;
    color: #2f2f2f !important;
}
.audio,
.video {
    border: 1px solid rgba(0, 0, 0, 0.2) !important;
    padding: 20px;
    margin: 15px 0;
    border-radius: 10px;
    position: relative;
}
</style>
